import http from '../_http_v2';

const forgery = {
  //default
  list: (m) => { return http.post(`console/wsfinder/forgery/list`, m); },
  detail: (m) => { return http.get(`console/wsfinder/forgery/${m.id}`); },

  //crud
  insert: (m) => { return http.post(`console/wsfinder/forgery`, m); },
  update: (m) => { return http.put(`console/wsfinder/forgery`, m); },
  delete: (m) => { return http.delete(`console/wsfinder/forgery/${m.id}`); },
}

export default forgery

export { forgery }